import extractErrorMessage from '../utils/extractErrorMessage';
import { authClient } from './client';

export const fetchReferralConfig = async () => {
  try {
    const response = await authClient.get('/admin/referral-config');
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri učitavanju podešavanja lojalnosti.'
    );
    return { data: null, success: false, message };
  }
};

export const updateReferralConfig = async (payload) => {
  try {
    const response = await authClient.patch('/admin/referral-config', payload);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri čuvanju podešavanja lojalnosti.'
    );
    return { data: null, success: false, message };
  }
};
